import { FrontendTariffDefinition } from './TariffDefinition.ts';
import { TariffCompatibility } from './TariffCompatibility.ts';

export type TariffState = 'planning' | 'released' | 'invalidated';

export type TariffDetail = {
    operatorId: number;
    internalName: string;
    state: TariffState;
    holidayListId: number | null;
    editable: boolean;
    hasZoneAssigned: boolean;
    hadZoneAssigned: boolean;
    multiTransactionLimit: MultiTransactionLimitConfig | null;
    tariffCompatibility: TariffCompatibility;
} & TariffCore;

export type TariffCore = {
    tariffId: number;
    name: string;
    tariffDefinition: FrontendTariffDefinition;
};

export interface MultiTransactionLimitConfig {
    level: MultiTransactionLimitLevel;
    limit1: MultiTransactionLimitEntry;
    limit2: MultiTransactionLimitEntry | null;
}

export interface MultiTransactionLimitEntry {
    type: MultiTransactionLimitType;
    amountRappen: number;
}

export const enum MultiTransactionLimitLevel {
    ENTITY = 'ENTITY',
    CUSTOMER = 'CUSTOMER',
}

export enum MultiTransactionLimitType {
    LAST_24H = 'LAST_24H',
    DAY = 'DAY',
    MONTH = 'MONTH',
}

export interface TariffListItem {
    tariffId: number;
    operatorId: number;
    name: string;
    internalName: string;
    state: TariffState;
    tariffDefinition: FrontendTariffDefinition;
    tariffCompatibility: TariffCompatibility;
    holidayListId: number | null;
    hasZoneAssigned: boolean;
    hadZoneAssigned: boolean;
}
